import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LandingRedirectComponent } from './components/landing-redirect/landing-redirect.component';

const routes: Routes = [
  {
    path: 'authentication',
    loadChildren: () => import('./authentication/authentication.module').then((m) => m.AuthenticationModule),
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./modules/dashboard/dashboard.module').then((m) => m.DashboardModule),
  },
  {
    path: 'partners',
    loadChildren: () => import('./modules/partners/partners.module').then((m) => m.PartnersModule),
  },
  {
    path: 'products',
    loadChildren: () => import('./modules/products/products.module').then((m) => m.ProductsModule),
  },
  {
    path: 'audit-log',
    loadChildren: () => import('./modules/audit-log/audit-log.module').then((m) => m.AuditLogModule),
  },
  {
    path: 'offer',
    loadChildren: () => import('./modules/offer/offer.module').then((m) => m.OfferModule),
  },
  {
    path: 'voucher',
    loadChildren: () => import('./modules/voucher/voucher.module').then((m) => m.VoucherModule),
  },
  {
    path: 'news',
    loadChildren: () => import('./modules/news/news.module').then((m) => m.NewsModule),
  },
  {
    path: 'banner',
    loadChildren: () => import('./modules/banner/banner.module').then((m) => m.BannerModule),
  },
  {
    path: 'receipt',
    loadChildren: () => import('./modules/receipt/receipt.module').then((m) => m.ReceiptModule),
  },
  {
    path: 'consumer',
    loadChildren: () => import('./modules/consumer/consumer.module').then((m) => m.ConsumerModule),
  },
  {
    path: 'profile-management',
    loadChildren: () => import('./modules/profile-management/profile-management.module').then((m) => m.ProfileManagementModule),
  },
  {
    path: 'change-password',
    loadChildren: () => import('./modules/change-password/change-password.module').then((m) => m.ChangePasswordModule),
  },
  {
    path: 'spin',
    loadChildren: () => import('./modules/spin/spin.module').then((m) => m.SpinModule),
  },
  {
    path: 'subscription',
    loadChildren: () => import('./modules/subscription/subscription.module').then((m) => m.SubscriptionModule),
  },
  {
    path: 'category',
    loadChildren: () => import('./modules/categories/category.module').then((m) => m.CategoryModule),
  },
  {
    path: 'chat',
    loadChildren: () => import('./modules/chat/chat.module').then((m) => m.ChatModule),
  },
  {
    path: 'product-catalogue',
    loadChildren: () => import('./modules/product-catalogue/product-catalogue.module').then((m) => m.ProductCatalogueModule),
  },
  {
    path: 'targeted-marketing',
    loadChildren: () => import('./modules/targeted-marketing/targeted-marketing.module').then((m) => m.TargetedMarketingModule),
  },
  {
    path: 'aieditor',
    loadChildren: () => import('./modules/aieditor/aieditor.module').then((m) => m.AieditorModule),
  },
  {
    path: 'hobbies-interest',
    loadChildren: () => import('./modules/hobbies-interest/hobbies-interest.module').then((m) => m.HobbiesInterestModule),
  },
  {
    path: 'delivery',
    loadChildren: () => import('./modules/delivery/delivery.module').then((m) => m.DeliveryModule),
  },
  {
    path: 'delivery-method',
    loadChildren: () => import('./modules/delivery-method/delivery-method.module').then((m) => m.DeliveryMethodModule),
  },
  {
    path: 'reward-inventory',
    loadChildren: () => import('./modules/reward-inventory/reward-inventory.module').then((m) => m.RewardInventoryModule),
  },
  {
    path: 'system-settings',
    loadChildren: () => import('./modules/system-settings/system-settings.module').then((m) => m.SystemSettingsModule),
  },
  {
    path: '',
    component: LandingRedirectComponent,
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: '/authentication/not-found', //Error 404 - Page not found
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
